"use client"

import Link from "next/link"
import { planBillingManageHref } from "@/lib/billing/plan-billing-routes"
import { MarketingHero } from "@/components/marketing/marketing-hero"
import { MarketingCalmHosting } from "@/components/marketing/marketing-calm-hosting"
import { MarketingProductJourney } from "@/components/marketing/marketing-product-journey"
import { MarketingMemoryPreview } from "@/components/marketing/marketing-memory-preview"
import { MarketingPlacesTrail } from "@/components/marketing/marketing-places-trail"
import { MarketingTrust } from "@/components/marketing/marketing-trust"
import { MarketingFinalCta } from "@/components/marketing/marketing-final-cta"

export function MarketingLanding() {
  return (
    <>
      <main className="app-shell min-w-0 pb-[var(--spacing-landing-main-pb)]">
        <MarketingHero />
        <MarketingCalmHosting />
        <MarketingProductJourney />
        <MarketingMemoryPreview />
        <MarketingPlacesTrail />
        <MarketingTrust />
        <MarketingFinalCta />
      </main>
      <footer className="app-shell border-t border-border/30 pb-14 pt-12 sm:pb-16">
        <div className="mx-auto max-w-[var(--max-width-mid)] text-center">
          <p className="type-body-sm font-medium text-foreground">MAATII</p>
          <p className="type-marketing-kicker mt-1">Events</p>
          <p className="type-body-sm mt-4 text-muted-foreground">
            Free to start; generous storage when you grow.
          </p>
          <p className="type-body-sm mt-3">
            <Link
              href="/pricing"
              className="underline-offset-4 hover:underline"
            >
              Pricing overview
            </Link>
            <span aria-hidden className="text-muted-foreground/60">
              {" "}
              ·{" "}
            </span>
            <Link
              href={`/sign-in?redirect_url=${encodeURIComponent(planBillingManageHref())}`}
              className="underline-offset-4 hover:underline"
            >
              Plan &amp; billing
            </Link>
            <span aria-hidden className="text-muted-foreground/60">
              {" "}
              ·{" "}
            </span>
            Need help?{" "}
            <a href="mailto:hello@maatii.co" className="underline-offset-4 hover:underline">
              hello@maatii.co
            </a>
          </p>
          <p className="type-caption mx-auto mt-6 max-w-md text-muted-foreground/80">
            &ldquo;In Him we live and move and have our being.&rdquo; — Acts 17:28
          </p>
        </div>
      </footer>
    </>
  )
}
